// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_dj-0";